import styled from "styled-components";

export const MainWrapper = styled.div`
  padding: 25px;
  @media only screen and (max-width: 1200px) {
    padding: 0;
  }
`;

export const LoadingContainer = styled.div`
  margin: 0 10px;
  display: flex;
  justify-content: center;
`;

export const LiveGames = styled.div`
  background-color: ${(props) => props.theme.backgroundColor};
  padding: 15px;
  width: 100%;
  border-radius: 5px;
  h2 {
    font-weight: 100;
  }
`;

export const LiveCards = styled.div`
  position: relative;
  background-color: ${(props) => props.theme.bottomColor};
  padding: 5px;
  margin-top: 10px;
  border-radius: 5px;

  overflow: hidden;
`;

export const LiveTeams = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  margin: 10px 0px;
  img {
    max-width: 100%;
    width: 20px;
    object-fit: contain;
  }
  span {
    font-size: 0.8rem;
  }
`;

export const GameBackImage = styled.div`
  position: absolute;
  right: -40px;
  top: -40px;
  img {
    filter: grayscale(100%);
    max-width: 100%;
    width: 100px;
    object-fit: contain;
    opacity: 0.1;
  }
`;

export const GamesButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;

  background-color: ${(props) => props.theme.secondary}1a;
  padding: 4px 8px;
  border: unset;
  border-radius: 5px;
  color: ${(props) => props.theme.secondary};
  margin-top: 10px;
`;

export const CouponContainer = styled.div`
  background-color: ${(props) => props.theme.backgroundColor};
  border-radius: 5px;
  padding: 16px;
  h2 {
    font-size: 1.6rem;
    font-weight: 100;
    margin-bottom: 20px;
  }
  .cupon-item {
    display: flex;
    flex-direction: column;
    margin-bottom: 10px;
    p {
      font-size: 1rem;
      color: ${(props) => props.theme.secondaryFont};
      margin-top: 16px;
    }

    .img-box {
      display: flex;
      div {
        display: flex;
        flex-direction: column;
        padding-left: 10px;
        position: relative;
        b {
          font-size: 0.8rem;
          font-weight: bold;
        }
        button {
          position: absolute;
          background: none;
          border: solid 1px #545455;
          padding: 10px;
          width: 100%;
          border-radius: 5px;
          font-size: 0.9rem;
          font-weight: 500;
          color: ${(props) => props.theme.secondaryFont};
          bottom: 5px;
          transition: ease 300ms;
          &:hover {
            background-color: #545455a1;
          }
        }
      }
      img {
        width: 100%;
        height: 70px;
        max-width: 180px;
        border-radius: 16px;
      }
    }
  }
`;
